import * as React from 'react';

import './style.scss';
import { StaticImage } from 'gatsby-plugin-image';

const ForumsSection = () => {
  return (
    <section className="l-forums-section">
      <div className="container">
        <h2 className="section-title">Forums Continued to Build the Professional Standards Community</h2>
        <p>
          The Councils delivered two Professional Standards Forums in the reporting period, to continue engagement with
          occupational associations and deliver encouragement and assistance for the development of associations’
          self-regulatory capacity.
        </p>

        <div className="grid">
          <div
            className="card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <StaticImage src="./assets/forum-1.jpg" alt="The Professional Standards Councils’ Chair, John Vines OAM presents at the October 2020 Professional Standards Forum" />
          </div>
          <div
            className="card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <StaticImage src="./assets/forum-2.png" alt="Panel members Andrew Lumsden, Lauren Solomon, Roxane Marcelle-Shaw and Kristen Wydell share in a question and answer session at the April 2021 Professional Standards Forum" />
          </div>
          <div
            className="feedback-card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <div className="quote">
              “I wanted to let you know how much I appreciated the Forum... the presentations were excellent and highly
              professional.”
            </div>
            <div className="author">- Attendee Feedback on the Forum</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForumsSection;
